import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/TrackingDevice.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function TrackingDevice() {
  const [startDate, setStartDate] = useState(new Date());
  const [reference_number, setReferenceNumber] = useState([]);
  const [transmitter_frequency, setTransmitterFrequency] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [tested, setTested] = useState("No");
  const [sedated, setSedated] = useState("No");
  const [sedated_reason, setSedatedReason] = useState("");
  const [photograph, setPhotograph] = useState("No");
  const [photograph_path, setPhotographPath] = useState("");
  const [comments, setComments] = useState("");
  const [options, setOptions] = useState([]);

  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  useEffect(() => {
    getReferences();
  }, []);

  async function submit() {
    const ref = reference_number[0];
    const items = {
      date: startDate,
      reference_number: ref,
      transmitter_frequency,
      manufacturer,
      tested,
      sedated,
      sedated_reason,
      photograph,
      photograph_path,
      comments,
    };
    var result = await axiosInstance.post("/api/add-tracking-device", items);
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setStartDate(new Date());
      setReferenceNumber([]);
      setTransmitterFrequency("");
      setManufacturer("");
      setTested("No");
      setSedated("No");
      setSedatedReason("");
      setPhotograph("No");
      setPhotographPath("");
      setComments("");
      setShowSuccess(true);
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  return (
    <div className="tracking">
      <div className="formGroup">
        <h2 className="heading">Tracking Device Attachment</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupNumber">
                <Form.Label>Transmitter Frequency</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Transmitter Frequency"
                  value={transmitter_frequency}
                  onChange={(e) => setTransmitterFrequency(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group as={Col} controlId="formGroupManufacturer">
                <Form.Label>Manufacturer</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Manufacturer"
                  value={manufacturer}
                  onChange={(e) => setManufacturer(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupTested">
                <Form.Label>Tested</Form.Label>
                <Form.Check
                  type="radio"
                  id="tested-radio-yes"
                  label="Yes"
                  name="testedRadios"
                  value="Yes"
                  onChange={(e) => setTested(e.target.value)}
                  checked={tested === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="tested-radio-no"
                  label="No"
                  name="testedRadios"
                  value="No"
                  onChange={(e) => setTested(e.target.value)}
                  checked={tested === "No"}
                />
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupSedated">
                <Form.Label>
                  Was the Pangolin Sedated/Anaesthetised for Fitting
                </Form.Label>
                <Form.Check
                  type="radio"
                  id="sedated-radio-yes"
                  label="Yes"
                  name="sedatedRadios"
                  value="Yes"
                  onChange={(e) => setSedated(e.target.value)}
                  checked={sedated === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="sedated-radio-no"
                  label="No"
                  name="sedatedRadios"
                  value="No"
                  onChange={(e) => setSedated(e.target.value)}
                  checked={sedated === "No"}
                />
                <br />
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Reason for Sedation/Anaesthetisation"
                  value={sedated_reason}
                  onChange={(e) => setSedatedReason(e.target.value)}
                  disabled={sedated === "No"}
                />
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupPhotograph">
                <Form.Label>Photograph Transmitter in Place</Form.Label>
                <Form.Check
                  type="radio"
                  id="photograph-radio-yes"
                  label="Yes"
                  name="photographRadios"
                  value="Yes"
                  onChange={(e) => setPhotograph(e.target.value)}
                  checked={photograph === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="photograph-radio-no"
                  label="No"
                  name="photographRadios"
                  value="No"
                  onChange={(e) => setPhotograph(e.target.value)}
                  checked={photograph === "No"}
                />
              </Form.Group>
              <Button disabled={photograph === "No"}>Upload Photo</Button>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>
                  In the Event of Multiple Transmitters (of the Same Kind) Being
                  Attached Successively - Briefly Describe the Circumstance and
                  Frequencies of Previous Transmitters
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments or Observations in the Event of Multiple Transmitters (of the Same Kind) Being
                  Attached Successively - Briefly Describe the Circumstance and
                  Frequencies of Previous Transmitters"
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
